<template>
    <div id="app">
        <page-header v-if="auth().loggedIn()"></page-header>
        <nav-bar v-if="auth().loggedIn()"></nav-bar>
        <navigation ref="navigation" v-if="auth().loggedIn()"></navigation>
        <notifications ref="notifications" v-if="auth().loggedIn()"></notifications>

        <div class="relative w-full -mt-8 pt-4 pb-2 bg-red-light px-4 text-center text-white"
             v-if="connectionStatus === 'offline'">
            You are currently offline. Any actions you do, will be sent to the server once you are online.
        </div>
        <div class="max-w-3xl mx-auto pb-16 mt-12 md:mt-40 md:pb-0 h-full">
            <transition
                    :name="transitionName"
                    :mode="transitionMode"
                    @beforeLeave="beforeLeave"
                    @enter="enter"
                    @afterEnter="afterEnter"
            >
                <router-view/>
            </transition>
        </div>
        <app-menu v-for="group in appGroups" :key="group.title" :title="group.title" :ref="group.title"
                  :apps="group.apps">
        </app-menu>
    </div>
</template>

<script>
    import PageHeader from './components/Header.vue'
    import Navigation from './components/Navigation.vue'
    import Notifications from './components/Notifications.vue'
    import NavBar from '@/components/NavBar.vue'
    import auth from './auth'
    import {mapState} from 'vuex'
    import HasSortedMenuItems from "./mixins/HasSortedMenuItems";

    const DEFAULT_TRANSITION = null;
    const DEFAULT_TRANSITION_MODE = 'out-in';
    export default {
        mixins: [HasSortedMenuItems],

        components: {
            PageHeader,
            Navigation,
            Notifications,
            NavBar
        },

        data() {
            return {
                transitionName: DEFAULT_TRANSITION,
                transitionMode: DEFAULT_TRANSITION_MODE,
            }
        },

        mounted() {
            if (auth.loggedIn()) {
                this.$store.commit('setConnectionStatus', 'online')

                auth.checkToken(loggedIn => {
                    if (loggedIn) {
                        this.$store.dispatch('fetchEmployee')
                        this.$store.dispatch('fetchEmployeeExtended')
                    } else {
                        this.$router.replace('/login');
                    }
                });

                this.$pendingApi('requests', 'hr').process()

            }
        },

        computed: {
            appGroups() {
                if (!this.apps.length) {
                    return [];
                }

                return this.sortedMenuItems.filter(item => item.subItems.length > 0).map(item => {
                    return {
                        route: item.route,
                        title: item.label,
                        apps: item.subItems
                    }
                })
            },
            ...mapState(['connectionStatus', 'apps']),
        },

        created() {

        },

        methods:
            {
                beforeLeave(element) {
                },
                enter(element) {
                },
                afterEnter(element) {
                },
                auth() {
                    return auth;
                }
            }
    }
</script>

<style>
    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }

    .zoom-enter-active,
    .zoom-leave-active {
        animation-duration: 0.5s;
        animation-fill-mode: both;
        animation-name: zoom;
    }

    .zoom-leave-active {
        animation-direction: reverse;
    }

    @keyframes zoom {
        from {
            opacity: 0;
            transform: scale3d(0.3, 0.3, 0.3);
        }

        100% {
            opacity: 1;
        }
    }
</style>
